import { Link } from "react-router";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck, faStar } from "@fortawesome/free-solid-svg-icons";

const BANKS = ["SBI", "HDFC", "ICICI Bank", "Axis Bank", "Piramal"];

const FOOTER_LINKS = [
  { label: "Home", to: "/" },
  { label: "Blog", to: "/blog" },
  { label: "About Us", to: "/about" },
  { label: "How it Works", to: "/how-it-works" },
  { label: "Contact Us", to: "/contact" }
];

function Footer() {
  return <footer className="vd-footer">
      <nav className="vd-footer-nav" aria-label="Footer">
        {FOOTER_LINKS.map((link) => <Link key={link.to} to={link.to}>
            {link.label}
          </Link>)}
      </nav>

      <div className="vd-footer-strip">
        <div className="vd-footer-trust">
          <span>Trusted By Thousands of Users</span>
          <span className="vd-stars" aria-hidden="true">
            {[...Array(4)].map((_, i) => <FontAwesomeIcon key={i} icon={faStar} />)}
          </span>
          <span className="vd-rating">4.8/5</span>
        </div>

        <div className="vd-footer-banks">
          <div className="vd-loan-badge">
            <FontAwesomeIcon icon={faCircleCheck} />
            Bank Loan Available
          </div>
          {BANKS.map((b) => <div key={b} className="vd-bank-pill">{b}</div>)}
        </div>
      </div>

      <div className="vd-footer-bottom">
        <p className="vd-footer-disclaimer">
          * Information displayed is for reference purposes only; buyers are advised to independently verify all details with the respective official authorities, developers, or authorized websites before making any investment decision.
        </p>
        <p className="vd-copyright">
          © {new Date().getFullYear()} VenturesDirectory. All rights reserved.
        </p>
      </div>
    </footer>;
}

export default Footer;
